const globalLogicService = {};

globalLogicService.encodeImageFileAsURL = element => {
  const self = this;
  const file = element.target.files[0];
  const reader = new FileReader();

  reader.onloadend = function() {
    // send the image to the getBase64ImageString() method
    self.getBase64ImageString(reader.result);
  };
  reader.readAsDataURL(file);
};

globalLogicService.getBase64ImageString = image => ({
  image
});

// ____________________________________________________
globalLogicService.logUserOut = callback => {
  globalLogicService.removeUserLocalStorageValues();

  callback();
};

// ____________________________________________________
// Check to see if user has a token.  Are they logged in?
globalLogicService.isUserLoggedIn = () => {
  const tokenActive = localStorage.getItem("ghv_app_user_token");

  return !!tokenActive;
};

// ____________________________________________________
globalLogicService.redirectUserToLoginIfNotLoggedIn = () => {
  const tokenActive = localStorage.getItem("ghv_app_user_token");

  if (!tokenActive) {
    window.location = "/login";
  }
};

// ____________________________________________________
globalLogicService.redirectUserToDashboardIfLoggedIn = () => {
  const tokenActive = localStorage.getItem("ghv_app_user_token");

  if (tokenActive) {
    window.location = "/";
  }
};

// ____________________________________________________
// Remove user values to localStorage
globalLogicService.removeUserLocalStorageValues = () => {
  localStorage.removeItem("ghv_app_user_id");
  localStorage.removeItem("ghv_app_user_token");
  localStorage.removeItem("ghv_app_user");
};

// ____________________________________________________
globalLogicService.setUserPrimaryStorageObject = data => {
  localStorage.setItem("ghv_app_user", JSON.stringify(data));
};

// ____________________________________________________
// Set user values to localStorage
globalLogicService.setUserLocalStorageValues = data => {
  // console.log(data.user_auth_object);
  if (data.user_id) localStorage.setItem("ghv_app_user_id", data.user_id);
  if (data.ghv_app_user_token)
    localStorage.setItem("ghv_app_user_token", data.ghv_app_user_token);
  if (data.user_auth_object && data.user_auth_object.ghv_app_user) {
    localStorage.setItem(
      "ghv_app_user_id",
      data.user_auth_object.ghv_app_user.user_id
    );
    localStorage.setItem(
      "ghv_app_user",
      JSON.stringify(data.user_auth_object.ghv_app_user)
    );
  }
  if (data.user_auth_object && data.user_auth_object.ghv_app_user_token) {
    localStorage.setItem(
      "ghv_app_user_token",
      data.user_auth_object.ghv_app_user_token
    );
  }
};

// ____________________________________________________
globalLogicService.imageHelper = (version, id, height, width) => {
  const cloudinaryUser = "someusername";
  const imagePrefix = `https://res.cloudinary.com/${cloudinaryUser}/image/upload/c_fill,`;

  return `${imagePrefix}h_${height},w_${width}/v${version}/${id}.jpg`;
};

// ____________________________________________________
globalLogicService.onReloadPage = () => {
  window.location.reload(true);
};

// ____________________________________________________
// Delay events functions
globalLogicService.delayActions = () => {
  let timer = 0;

  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
};

// ____________________________________________________
globalLogicService.onClickCancelProcessFunction = element => {
  element.onclick = function() {
    // console.log('Cancel this process.');

    window.location.reload(true);
  };
};

globalLogicService.onActivatePleaseWaitBlock = () => {
  const cancelProcessButton = document.querySelector("#cancel-process-button");
  const appBody = document.querySelector("#app-body");
  const globalMessageWrap = document.querySelector("#global-message-wrap");
  const globalWaitingBlock = document.querySelector("#global-waiting-block");
  const globalMessageTingBlock = document.querySelector(
    "#global-message-tint-block"
  );

  this.onClickCancelProcessFunction(cancelProcessButton);

  appBody.classList.add("kill-body-scroll");
  globalMessageWrap.classList.add("display-element");
  globalWaitingBlock.classList.add("display-element");
  globalMessageTingBlock.classList.add("display-element");
};

// ____________________________________________________
globalLogicService.onDeactivatePleaseWaitBlock = () => {
  const appBody = document.querySelector("#app-body");
  const globalMessageWrap = document.querySelector("#global-message-wrap");
  const globalWaitingBlock = document.querySelector("#global-waiting-block");
  const globalMessageTingBlock = document.querySelector(
    "#global-message-tint-block"
  );

  appBody.classList.remove("kill-body-scroll");
  globalMessageWrap.classList.remove("display-element");
  globalWaitingBlock.classList.remove("display-element");
  globalMessageTingBlock.classList.remove("display-element");
};

// ____________________________________________________
globalLogicService.onActivateTimedMessageBlock = (message, timeValue) => {
  const appBody = document.querySelector("#app-body");
  const globalMessageWrap = document.querySelector("#global-message-wrap");
  const messageBlock = document.querySelector("#message-block");
  const displayMessgage = message;

  appBody.classList.add("kill-body-scroll");
  globalMessageWrap.classList.add("display-element");
  messageBlock.classList.add("display-element");
  messageBlock.innerHTML = `<span>${displayMessgage}</span>`;

  const closeMessgeBlock = () => {
    appBody.classList.remove("kill-body-scroll");
    globalMessageWrap.classList.remove("display-element");
    messageBlock.classList.remove("display-element");
    messageBlock.innerHTML = "";
  };

  window.setTimeout(closeMessgeBlock, timeValue);
};

// ____________________________________________________
globalLogicService.scrollToTopOfPage = () => {
  // console.log('Scrolling to the top.');
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

// ____________________________________________________

export default globalLogicService;
